/* eslint-disable react/no-unescaped-entities */

import { Col, Row, Typography } from 'antd'
import * as React from 'react'
import './custom-index.css'
import LoginView from './login'
import LogoutButton from './logout'
import AuthProvider from './provider'

const AuthWrapper: React.FC<{component: any}> = ({ component: Component, ...props }) => {
  return (
    <Row
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        padding: 60,
        paddingTop: 72,
        maxWidth: 1024,
        margin: '0 auto',
        minHeight: '100vh',
      }}
    >
      <Col
        xs={24}
        xl={16}
        className="pc__BrandSection"
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 12,
        }}
      >
        <img src="/img/brand/powcloud-logo-400w.png" height="28" alt="PowCloud" style={{ marginBottom: 5 }} />
        <div style={{ textAlign: 'center' }}>
          <Typography.Text>
            Home of <b>Form</b>topia &mdash; the world's fastest form builder.
          </Typography.Text>
        </div>
      </Col>
      <Col xs={24} xl={8}>
        <Component {...props} />
      </Col>
      <Col>&nbsp;</Col>
    </Row>
  )
}

const LoginWrapper = (props) => <AuthWrapper {...props} component={LoginView} />

export default class DashAuth {
  static Login = LoginWrapper
  static LogoutButton = LogoutButton
  static Provider = AuthProvider
}
